import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class InstallerAuthGuard {

    constructor(private router: Router, private storageService: StorageService) { }

    canActivate() {
        if (this.storageService.getStorageItem('isLoggedin')) {
            return true;
        }

        this.router.navigate(['/login']);
        return false;
    }

}
